import { useEffect, useState } from 'react';

import axios from 'axios';

const api = axios.create({
  baseURL: '/api/v1',
  headers: {
    Authorization: `Bearer ${window.api_token}`,
    Accept: 'application/json',
  },
});

export const useApiGet = ({ url, params, transformer }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    let mounted = true;
    setIsLoading(true);
    api
      .get(url, {
        params,
      })
      .then((apiResponse) => {
        if (!mounted) {
          return;
        }
        const { data } = apiResponse.data;
        if (transformer) {
          if (Array.isArray(data)) {
            setResponse(data.map(transformer));
          } else {
            setResponse(transformer(data));
          }
        } else {
          setResponse(data);
        }
        setIsLoading(false);
      })
      .catch((apiError) => {
        console.error(apiError);
        setError(apiError);
      });

    return () => {
      mounted = false;
    };
  }, [url, params, transformer]);

  return {
    isLoading,
    response,
    error,
  };
};

export default api;
